import React, { useState, useEffect } from "react";
import { QuestionnairePagePanels } from "./common/QuestionnairePagePanels";

export const QuestionnaireFooter = ({ def }) => {
	const [panels, setPanels] = useState();

	useEffect(() => {
		if (def?.footer?.panels) {
			setPanels(def.footer.panels);
		}
	}, [def]);

	if (!panels) {
		return <></>;
	}

	return <QuestionnairePagePanels panels={panels} />;
};
